import { useState, useCallback, useEffect } from "react";
import { ImageMap } from "./ImageMap.js";
import { LocationSheet } from "./LocationSheet.js";
import { MapHeader } from "./MapHeader.js";
import { locations as fallbackLocations, type Location } from "../data/locations.js";

export function AsakusaMap() {
  const [activeLocation, setActiveLocation] = useState<Location | null>(null);
  const [locations, setLocations] = useState<Location[]>(fallbackLocations);

  // Load pins from server (KV), fallback to hardcoded data
  useEffect(() => {
    fetch("/api/pins")
      .then((r) => r.json())
      .then((data: Location[]) => {
        if (Array.isArray(data) && data.length > 0) {
          setLocations(data);
        }
      })
      .catch(() => {
        // Use fallback hardcoded locations
      });
  }, []);

  const handlePinClick = useCallback((location: Location) => {
    setActiveLocation((prev) => (prev?.id === location.id ? null : location));
  }, []);

  const handleSheetClose = useCallback(() => {
    setActiveLocation(null);
  }, []);

  return (
    <div className="fixed inset-0 bg-surface-1">
      <ImageMap
        activeLocation={activeLocation}
        onPinClick={handlePinClick}
        locations={locations}
      />
      <MapHeader />
      <LocationSheet location={activeLocation} onClose={handleSheetClose} />
    </div>
  );
}
